export const getCombinedPower = (prescription) => {
  let A = parseFloat(String(prescription.SPH?.OD || 0));
  A +=
    prescription.rxType === "READING"
      ? parseFloat(String(prescription.ADD?.OD || 0))
      : 0;

  const B =
    A +
    (prescription.CYL?.OD !== undefined && prescription.CYL?.OD !== null
      ? parseFloat(String(prescription.CYL.OD))
      : 0.0);

  let C = parseFloat(String(prescription.SPH?.OS || 0));
  C +=
    prescription.rxType === "READING"
      ? parseFloat(String(prescription.ADD?.OS || 0))
      : 0;

  const D =
    C +
    (prescription.CYL?.OS !== undefined && prescription.CYL?.OS !== null
      ? parseFloat(String(prescription.CYL.OS))
      : 0.0);

  return Math.max(A, B, C, D);
};

export const hasValidPrescription = (currentPackage, prescription) => {
  if (!prescription) return true;
  if (
    !["manual", "nested_ca", "account"].includes(
      prescription.prescriptionFlow?.toString().toLowerCase()
    )
  ) {
    return true;
  }

  const nullValues = [null, undefined, NaN];
  const sphMin = parseFloat(currentPackage.lensPackage.rxValues?.sph?.min);
  const sphMax = parseFloat(currentPackage.lensPackage.rxValues?.sph?.max);
  const cylMin = parseFloat(currentPackage.lensPackage.rxValues?.cyl?.min);
  const cylMax = parseFloat(currentPackage.lensPackage.rxValues?.cyl?.max);
  const addMin = parseFloat(currentPackage.lensPackage.rxValues?.add?.min);
  const addMax = parseFloat(currentPackage.lensPackage.rxValues?.add?.max);

  if (
    nullValues.includes(sphMin) ||
    nullValues.includes(sphMax) ||
    nullValues.includes(cylMin) ||
    nullValues.includes(cylMax)
  ) {
    return false;
  }

  const combinedTotalPower = getCombinedPower(prescription);
  if (
    combinedTotalPower >= sphMin &&
    combinedTotalPower <= sphMax &&
    (!prescription.CYL ||
      (parseFloat(String(prescription.CYL?.OD)) >= cylMin &&
        parseFloat(String(prescription.CYL?.OD)) <= cylMax &&
        parseFloat(String(prescription.CYL?.OS)) >= cylMin &&
        parseFloat(String(prescription.CYL?.OS)) <= cylMax))
  ) {
    // progressive case
    if (
      currentPackage.type === "progressive" &&
      (prescription.ADD?.OD || prescription.ADD?.OS)
    ) {
      if (
        parseFloat(String(prescription.ADD.OD)) >= addMin &&
        parseFloat(String(prescription.ADD.OD)) <= addMax
      ) {
        return true;
      }
    } else {
      return true;
    }
  }
};
